var _defs, _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _polygon, _path2, _path3, _rect8, _path4, _rect9, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherConditions = function SvgWeatherConditions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 487.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -83.7,
    y1: 313.89,
    x2: 236.3,
    y2: -17.11,
    gradientTransform: "translate(143.2 26.2) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -70.17,
    y1: 326.97,
    x2: 249.83,
    y2: -4.03,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 15.23,
    y1: 409.53,
    x2: 335.23,
    y2: 78.53,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -27.74,
    y1: 367.98,
    x2: 292.26,
    y2: 36.98,
    gradientTransform: "translate(222.39 59.01) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 114.44,
    y1: 505.44,
    x2: 434.44,
    y2: 174.44,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 180.31,
    y1: 569.13,
    x2: 500.31,
    y2: 238.13,
    gradientTransform: "translate(409.81 -65.45) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 151.37,
    y1: 541.14,
    x2: 471.37,
    y2: 210.14,
    gradientTransform: "translate(393.41 -25.86) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 122.42,
    y1: 513.16,
    x2: 442.42,
    y2: 182.16,
    gradientTransform: "translate(377 13.73) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -20.28,
    y1: 375.2,
    x2: 299.72,
    y2: 44.2,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 117.49,
    y1: 508.39,
    x2: 437.49,
    y2: 177.39,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 143.41,
    y1: 533.45,
    x2: 463.41,
    y2: 202.45,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 62.29,
    y1: 455.03,
    x2: 382.29,
    y2: 124.03,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -26.76,
    y1: 368.94,
    x2: 293.24,
    y2: 37.94,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 16.67,
    y1: 410.92,
    x2: 336.67,
    y2: 79.92,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -68.72,
    y1: 328.37,
    x2: 251.28,
    y2: -2.63,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 30.15,
    y1: 423.95,
    x2: 350.15,
    y2: 92.95,
    gradientTransform: "translate(255.2 -20.17) rotate(45)",
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 31.97,
    y: 174.65,
    width: 16,
    height: 22.62,
    transform: "translate(-119.79 82.73) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 233.98,
    width: 24,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 88,
    y: 313.98,
    width: 16,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.65,
    y: 289.95,
    width: 22.62,
    height: 16,
    transform: "translate(-198.98 115.52) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M304,329.98c0-35.35-28.65-64-64-64s-64,28.65-64,64c-26.51,0-48,21.49-48,48s21.49,48,48,48h128c26.51,0,48-21.49,48-48s-21.49-48-48-48ZM304,409.98h-128c-17.67,0-32-14.33-32-32s14.33-32,32-32,32,14.33,32,32h16c-.03-20.3-12.8-38.39-31.91-45.22-.05-.93-.09-1.85-.09-2.78,0-26.51,21.49-48,48-48,26.51,0,48,21.49,48,48,0,12.9-5.19,25.26-14.41,34.29l11.2,11.43c8.33-8.12,14.28-18.37,17.19-29.64.67-.04,1.35-.07,2.02-.07,17.67,0,32,14.33,32,32s-14.33,32-32,32Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 255.64,
    y: 453.96,
    width: 56.56,
    height: 16,
    transform: "translate(-243.5 336.07) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 199.64,
    y: 453.95,
    width: 56.56,
    height: 16,
    transform: "translate(-259.89 296.47) rotate(-45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 143.65,
    y: 453.95,
    width: 56.56,
    height: 16,
    transform: "translate(-276.29 256.87) rotate(-45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "131.02 133.95 142.21 145.39 174.34 113.98 225.7 113.98 199.42 156.75 155.33 167.51 159.12 183.05 187.52 176.12 175.51 195.66 189.15 204.04 201.43 184.04 208.55 211.96 224.06 208 213.1 165.05 240 121.26 266.9 165.05 255.94 208 271.45 211.96 278.57 184.04 290.85 204.04 304.49 195.66 292.48 176.12 320.88 183.05 324.67 167.51 280.58 156.75 254.3 113.98 305.66 113.98 337.79 145.39 348.98 133.95 328.55 113.98 352 113.98 352 97.98 328.55 97.98 348.98 78.01 337.79 66.56 305.66 97.98 254.3 97.98 280.58 55.2 324.67 44.45 320.88 28.9 292.48 35.83 304.49 16.29 290.85 7.92 278.57 27.92 271.45 0 255.94 3.96 266.9 46.91 240 90.7 213.1 46.91 224.06 3.96 208.55 0 201.43 27.92 189.15 7.92 175.51 16.29 187.52 35.83 159.12 28.9 155.33 44.45 199.42 55.2 225.7 97.98 174.34 97.98 142.21 66.56 131.02 78.01 151.45 97.98 128 97.98 128 113.98 151.45 113.98 131.02 133.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M448,177.98h-16v16h16c8.84,0,16,7.16,16,16s-7.16,16-16,16h-144v16h144c17.67,0,32-14.33,32-32s-14.33-32-32-32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M416,257.98h-88v16h88c8.84,0,16,7.16,16,16s-7.16,16-16,16h-24v16h24c17.67,0,32-14.33,32-32s-14.33-32-32-32Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 264,
    y: 225.98,
    width: 24,
    height: 16
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152,241.98c0-30.93-25.07-56-56-56s-56,25.07-56,56,25.07,56,56,56c30.91-.03,55.97-25.09,56-56ZM56,241.98c0-22.09,17.91-40,40-40s40,17.91,40,40-17.91,40-40,40c-22.08-.03-39.97-17.92-40-40Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 168,
    y: 233.98,
    width: 24,
    height: 16
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88,
    y: 145.98,
    width: 16,
    height: 24
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 143.95,
    y: 286.65,
    width: 16,
    height: 22.62,
    transform: "translate(-166.19 194.71) rotate(-45)"
  })));
};
export default SvgWeatherConditions;